import { render, staticRenderFns } from "./task.vue?vue&type=template&id=34542904"
import script from "./task.ts?vue&type=script&lang=ts&external"
export * from "./task.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports